<template>
  <div>
    <div id="main1" :style="{ width: '100%', height: '100%' }"></div>
  </div>
</template>

<script>
export default {
  props: ["echatsmsg"],
  data() {
    return {
      iaChart: "",
      //横轴数据
      axs: [],
      //数据name
      name: [],
      //黑名单消费数据
      blackconsumption: [],
      //打电话消费
      phons: [],
      yuezu: [],
      //数据集
      serri: [],
    };
  },
  created() {},
  mounted() {
    // console.log('echatsmsg',this.echatsmsg);
    // const that = this;
    // window.onresize = () => {
    //   that.iaChart.resize();
    // };
  },
  watch: {
    echatsmsg(newVal) {
      if (newVal) {
        if (newVal !== undefined) {
          this.drawLine(newVal);
        }
      }
    },
  },
  methods: {
    drawLine(index) {
      this.axs = index.map((item) => {
        if (item.hour) {
          return item.hour > 9 ? item.hour + ":00" : "0" + item.hour + ":00";
        } else {
          return item.day ? item.day : "";
        }
      });
      this.name = "实时在线人数";
      this.blackconsumption = index.map((item) => Number(item.num));
      var echarts = require("echarts");
      var myChart = (this.iaChart = echarts.init(
        document.getElementById("main1")
      ));
      //配置项和数组
      myChart.setOption({
        //option
        title: {
          text: "实时在线人数",
          // subtext: '单位（元）',
          textStyle: {
            //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
            fontSize: 18,
            fontStyle: "normal",
            fontWeight: "bold",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        //图例
        legend: {
          orient: "horizontal",
          x: "right",
          y: "top",
        },
        //调色盘
        color: ["#F16D34", "#FFAD26", "#26A7FF"],
        //横坐标
        xAxis: {
          data: this.axs,
        },
        //纵坐标
        yAxis: {
          minInterval: 1, //分割刻度
        },
        //布局
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        //数据集
        series: [
          {
            name: this.name,
            type: "line",
            smooth: false,
            symbol: "circle",
            symbolSize: 1,
            smooth: true,
            itemStyle: {
              color: "#82C2FB",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#82C2FB",
                },
                {
                  offset: 0.5,
                  color: "#FFFFFF",
                },
              ]),
            },
            stack: "广告",
            label: {
              show: false,
            },
            emphasis: {
              focus: "series",
            },
            data: this.blackconsumption,
          },
        ],
      });
    },
  },
};
</script>

<style scoped lang="less"></style>
